import { useState } from "react";
import type { ReactNode } from "react";
import { isMockMode } from "../../api/client";
import type { Tone } from "./helpers";

interface BadgeProps {
  tone?: Tone;
  size?: "md" | "sm" | "xs";
  mono?: boolean;
  title?: string;
  children: ReactNode;
}

export function Badge({ tone = "neutral", size = "md", mono, title, children }: BadgeProps) {
  const cls = ["amz-badge", `t-${tone}`, size !== "md" ? size : "", mono ? "mono" : ""].filter(Boolean).join(" ");
  return (
    <span className={cls} title={title}>
      {children}
    </span>
  );
}

interface ThumbProps {
  url: string | null;
  large?: boolean;
}

/** 斜線パターンのプレースホルダ。実運用では画像URLがあれば表示し、失敗したらプレースホルダに戻す。mockでは外部通信しない。 */
export function Thumb({ url, large }: ThumbProps) {
  const [failed, setFailed] = useState(false);
  const show = !!url && !failed && !isMockMode();
  return (
    <div className={`amz-thumb ${large ? "lg" : ""}`}>
      {show && <img src={url ?? ""} alt="" loading="lazy" onError={() => setFailed(true)} />}
    </div>
  );
}

export function Spinner({ size }: { size?: "sm" | "lg" }) {
  return <span className={`amz-spin ${size ?? ""}`} aria-hidden="true" />;
}
